import Alert from "@mui/material/Alert";
import DynamicMessagePage from "./DynamicMessagePage";
import SpecialEventPage from "./SpecialEventPage";
import LocalMessagePage from "./LocalMessagePage";
import DeploymentPage from "./DeploymentPage";
import SimulatePage from "./SimulatePage";
import HelpPage from "./HelpPage";
import MiscPage from "./MiscPage";

const CONFIG_PAGES = [0, 1, 2, 3, 4];

function DrawerManager(props) {
  const renderPage = () => {
    switch (props.page) {
      case 0:
        return <DynamicMessagePage />;
      case 1:
        return <SpecialEventPage />;
      case 2:
        return <HelpPage />;
      case 3:
        return <LocalMessagePage />;
      case 4:
        return <MiscPage />;
      case 98:
        return <SimulatePage />;
      case 99:
        return <DeploymentPage />;
      default:
        return <p>Something went wrong</p>;
    }
  };

  const showNote = CONFIG_PAGES.includes(props.page);

  return (
    <>
      {showNote && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Edits are temporarily stored. Go to the Deployment tab to publish your configuration.
        </Alert>
      )}
      {renderPage()}
    </>
  );
}

export default DrawerManager;

